<template>
  <v-subheader class="text-caption pa-0" style="height: auto;" v-on="!disabled && $listeners">
    <a
      :class="[disabled && 'text--disabled', 'text-decoration-underline link--text font-italic']"
      v-text="$i18n.t(translationPath)"
    >
    </a>
  </v-subheader>
</template>

<script>
export default {
  name: 'LinkUnderlined',
  props: {
    translationPath: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.text--disabled {
  cursor: default !important;
}
</style>
